import { useEffect, useState } from 'react';

const sameLocalDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

/**
 * "Hoje" para os rótulos de horário ("14:05", "Ontem"…). Com a tela aberta a noite toda, o que era
 * "14:05" precisa virar "Ontem" na virada do dia. Só muda de identidade quando o dia muda, então
 * a conferência a cada minuto não redesenha a lista à toa.
 */
export function useToday(checkEveryMs = 60_000): Date {
  const [today, setToday] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      setToday((current) => (sameLocalDay(current, now) ? current : now));
    }, checkEveryMs);
    return () => clearInterval(timer);
  }, [checkEveryMs]);

  return today;
}
